import Vue from 'vue';
import ElementUI from 'element-ui';
import VeeValidate, { Validator } from 'vee-validate';
import 'element-ui/lib/theme-chalk/index.css';
import './pipes/pipes';

import App from './App.vue';
import router from './router';
import './styles/styles.scss';
import handleError from './error-handler';

Vue.config.productionTip = false;

window.sm = {
  url: process.env.VUE_APP_API_URL,
};

Vue.config.errorHandler = handleError;

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  }

  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  if (!nearestWithMeta) {
    return next();
  }

  nearestWithMeta.meta.metaTags
    .map((tagDef) => {
      const tag = document.createElement('meta');

      Object.keys(tagDef).forEach(key => tag.setAttribute(key, tagDef[key]));

      tag.setAttribute('data-vue-router-controlled', '');

      return tag;
    })
    .forEach(tag => document.head.appendChild(tag));

  next();
  return false;
});

Vue.use(ElementUI);
Vue.use(VeeValidate);

Vue.prototype.$eventHub = new Vue(); // Global event bus

// Validate Phone Number
const phoneNumber = {
  getMessage: field => `${field} is not a valid phone number`,
  validate(value) {
    return new Promise((resolve) => {
      // eslint-disable-next-line
      const phoneRegex = /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/g;
      const valid = phoneRegex.test(value);
      resolve({ valid });
    });
  },
};
Validator.extend('phoneNumber', phoneNumber);


new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
